<div class="mc-button-wrapper">
    <ng-content></ng-content>
</div>
<div class="mc-button-overlay" (click)="haltDisabledEvents($event)"></div>
